<template>
  <div class="flex flexy wrap">
    <div class="flex flexw">
      <div class="flex align-start wrap">
        <span class="sm-font flex column label r8">
          <span>Event</span>
          <itime
            class="update-text"
            :timestamp="
              $store.state.items[$route.params.type][$route.params.iitemid]
                .events.date
            "
          ></itime>
          <span>{{
            $store.state.items[$route.params.type][$route.params.iitemid].events
              .private
              ? "Private"
              : "Public"
          }}</span>
        </span>
      </div>
      <div class="sub-container b8 flexw">
        <b class="sm-font">Location</b>
        <div>
          {{
            $store.state.items[$route.params.type][$route.params.iitemid].events
              .location
          }}
        </div>
      </div>
    </div>
    <div class="flex around wrap flexy">
      <div
        class="flex xs-font center"
        :key="statKey"
        v-for="(stat, statKey) in ['going', 'notgoing', 'interested']"
      >
        <div class="flex wrap align-center column">
          <div
            v-if="$store.state.events[eType] && $store.state.events[eType][eId]"
          >
            <span
              class="r4"
              v-if="
                $store.state.events[eType] && $store.state.events[eType][eId]
              "
              >{{
                $store.state.events[eType][eId][stat]
                  ? $store.state.events[eType][eId][stat].length
                  : 0
              }}</span
            >
            <b>{{ stat.toUpperCase() }}</b>
          </div>
          <button
            type="button"
            :class="`p16 ${
              $store.state.related.events[$route.params.type] &&
              $store.state.related.events[$route.params.type][
                $route.params.iitemid
              ] === stat
                ? 'indicate'
                : ''
            }`"
            :style="
              $store.state.events[eType] &&
              $store.state.events[eType][eId] &&
              $store.state.events[eType][eId][stat] &&
              $store.state.events[eType][eId][stat].indexOf(
                $store.state.auth.uid
              ) > -1
                ? 'font-weight: 600'
                : ''
            "
            @click="
              attendEvent(
                $store.state.related.events[$route.params.type] &&
                  $store.state.related.events[$route.params.type][
                    $route.params.iitemid
                  ] === stat
                  ? ''
                  : stat
              )
            "
          >
            <i
              :class="`fas fa-${
                $store.state.related.events[$route.params.type] &&
                $store.state.related.events[$route.params.type][
                  $route.params.iitemid
                ] === stat
                  ? 'check-square'
                  : 'square'
              } fa-2x`"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    name() {
      return "attend";
    },
    status() {
      return this.$store.dispatch("query", {
        type: "event",
        id: this.eId || this.$route.params.iitemid,
        itemType: this.eType,
      });
    },
  },
  methods: {
    attendEvent(stat) {
      var relateObj = {
        secret:
          this.$store.state.events[this.eType] &&
          this.$store.state.events[this.eType][this.eId]
            ? this.$store.state.items[this.eType][this.eId].secret
            : false,
        status: stat,
        type: "events",
        id: this.eId,
        itemType: this.eType,
      };
      this.$store.dispatch("relate", relateObj).then(() => {
        this.$set(
          this.$store.state.componentKeys,
          "events",
          this.$store.state.componentKeys.events + 1
        );
      });
    },
  },
  mounted() {
    this.$store.dispatch("query", {
      type: "event",
      itemType: this.eType,
      id: this.eId || this.$route.params.iitemid,
    });
  },
  props: { eId: { type: String }, eType: { type: String } },
};
</script>